import React from 'react';
import AccompanimentExecutive from './accompaniment/AccompanimentExecutive';
import AccompanimentBroker from './accompaniment/AccompanimentBroker';
import AccompanimentDirector from './accompaniment/AccompanimentDirector';
import AccompanimentCoordinator from './accompaniment/AccompanimentCoordinator'; 
import Filters from './Filters';
import cn from 'classnames';

export default class AccompanimentReport extends React.Component {

    constructor(props) {
        super(props);

        this.setActiveTab = this._setActiveTab.bind(this);
        this.fetchReports = this._fetchReports.bind(this);
        this.filterChange = this._filterChange.bind(this);
        this.renderTab = this._renderTab.bind(this);
        this.state = {
            activeTab : 'executive',
            filters : {}
        }
        this.fetchReports(1);
    }

    _setActiveTab(activeTab) {
        this.setState({activeTab}, this.fetchReports);
           
    }

    _filterChange(data) {
        this.setState({
            filters : data,
        }, this.fetchReports);
    }

    _fetchReports(page) {
        this.props.fetchReports('accompaniment-' + this.state.activeTab, page, this.state.filters);
    }

    _renderTab() {
        if(this.state.activeTab === 'executive') {
            return (
                <AccompanimentExecutive
                    territories={this.props.territories}
                    coordinations={this.props.coordinations}
                    data={(this.props.reportsState.accompaniment_executive || {}).data}
                    changePage={this.fetchReports}/>
            ); 
        }else if(this.state.activeTab === 'broker') {
            return (
                <AccompanimentBroker
                    territories={this.props.territories}
                    coordinations={this.props.coordinations}
                    data={(this.props.reportsState.accompaniment_broker || {}).data}
                    changePage={this.fetchReports}/>
            );
        } else if(this.state.activeTab === 'director') {
            return (
                <AccompanimentDirector
                    territories={this.props.territories}
                    coordinations={this.props.coordinations}
                    data={(this.props.reportsState.accompaniment_director || {}).data}
                    changePage={this.fetchReports}/>
            );
        } else if(this.state.activeTab === 'coordinator') {
            return (
                <AccompanimentCoordinator
                    territories={this.props.territories}
                    coordinations={this.props.coordinations}
                    data={(this.props.reportsState.accompaniment_coordinator || {}).data}
                    changePage={this.fetchReports}/>
            );
        }else {
            return null;    
        }
        
    }

    render() {
        return (
            <div className="container">
                <ul className="nav nav-tabs mb-3">
                    <li className="nav-item">
                        <a href="#" className={cn('nav-link', {'active' : 'executive' === this.state.activeTab})} onClick={() => this.setActiveTab('executive')}>
                            Asesores
                        </a>
                    </li>
                    <li className="nav-item">
                        <a href="#" className={cn('nav-link', {'active' : 'broker' === this.state.activeTab})} onClick={() => this.setActiveTab('broker')}>
                            Broker
                        </a>
                    </li>
                    <li className="nav-item">
                        <a href="#" className={cn('nav-link', {'active' : 'director' === this.state.activeTab})} onClick={() => this.setActiveTab('director')}>
                            Director
                        </a>
                    </li>
                    <li className="nav-item">
                        <a href="#" className={cn('nav-link', {'active' : 'coordinator' === this.state.activeTab})} onClick={() => this.setActiveTab('coordinator')}>
                            Subdirector-Coordinador
                        </a>
                    </li>
                </ul>

                <Filters 
                    requestXlsx={this.props.requestXlsx}
                    report={'accompaniment-' + this.state.activeTab}
                    territories={this.props.territories}
                    coordinations={this.props.coordinations}
                    users={this.props.users}  
                    onFilterChange={this.filterChange}  
                />
                
                {
                    (this.props.reportsState['accompaniment_' + this.state.activeTab] || {}).fetching ? 
                        <div className="my-2">
                            <i className="fa fa-spinner fa-spin"></i> Cargando
                        </div>
                    :
                        this.renderTab()
                        
                }
            </div>
        );
    }
}


/** WEBPACK FOOTER **
 ** ./src/components/presentation/reports/AccompanimentReport.jsx
 **/